import { render, staticRenderFns } from "./ResumeAdvertisementButton.vue?vue&type=template&id=38ced0b1&"
import script from "./ResumeAdvertisementButton.vue?vue&type=script&lang=ts&"
export * from "./ResumeAdvertisementButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports